const { withPrefix } = require("gatsby")
const root = withPrefix("/lcb/Admin/EmploymentOpportunities")

const formatDivisionEndpoint = division =>
  division
  .trim()
    .toString()
    .toLowerCase()
   .replace(/-/g, "X")  // if string has a dash then set to X to indicate this was a user created dash not a prismic added dash
    .replace(/ /g,"-")  // now replace all the spaces with dashes since this is how gatsby created the dynamic pages
    .replace(/-X-/g,"-") //re-add the dashes that were part of the user defined division name
    .replace(/'/g,"-") //replace aphostropies with dashes

export const linkResolver = division => {
    return `${root}/${formatDivisionEndpoint(division)}`
}

export const gatsbyLinkResolver = division => {
  return `/${formatDivisionEndpoint(division)}`
}
